import { YourlearningNavBar } from "../nav-bars/your-learning-nav";
import { HtmlElementProps, Typography } from '@uni-of-exeter/digital.lib.react.ui.kit';
import { Outlet } from "react-router-dom";
import './styles/your-learning-wrapper.css'
import { APP_TEXT } from "../../const/app-text";

export type PageWrapperProps = HtmlElementProps<HTMLDivElement>
const yourLearningTitle = APP_TEXT.pages.yourLearning.title;

export const YourLearningWrapper = () => {

    return (
        <div className="pageContainer">
            <div className="topWrapperContainer">
                <Typography
                    variant="h1.bold"
                    className="yourLearningSectionTitle"
                >
                    {yourLearningTitle}
                </Typography>

                <YourlearningNavBar />
            </div>

            <div className="contentContainer">
                <Outlet />
            </div>
        </div>
    );
};